<template>
  <div class="type">
    <div class="type__authorised" @click="toggleAuthorised(true)">{{ $t('authorised') }}</div>
  </div>
</template>

<script>
  export default {
    name: 'Type',
    methods: {
      toggleAuthorised (bool) {
        this.$store.commit('showLegalModal', bool)
      }
    }
  }
</script>

<style scoped>
  .type {
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 5;
    -webkit-backdrop-filter: blur(10px);
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem;
    box-sizing: border-box;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    background: rgba(255, 255, 255, .1)
  }
  .type__authorised {
    pointer-events: auto;
    font-size: 12px;
    border-bottom: 1px solid #000;
    padding-bottom: 1px;
    margin-left: auto;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// Type.vue?e33edbaa